<template>
  <div v-if="showCurrentVoteStatus" class="current-vote-status">
    <template v-if="faIcon">
      <!-- visualisierung via icons-->
      <div aria-hidden="true">
        <span class="">
          Verfügbare {{ weightedPointsWord }}: {{ currentVote.max - currentVote.used }} von {{ currentVote.max }}
          <br />
        </span>
        <span v-for="(rowArray, index) in iconsArray" :key="index" class="outer col">
          <span v-for="(val, index) in rowArray" :key="index" class="support_weight-icon" :class="val">
            <font-awesome-layers>
              <font-awesome-icon :icon="faIcon" />
              <font-awesome-icon v-if="val == 'used'" icon="slash-forward" style="color: #444" />
            </font-awesome-layers>
          </span>
          <br />
        </span>
      </div>
      <span class="visually-hidden">
        Verfügbare {{ weightedPointsWord }}: {{ currentVote.max - currentVote.used }} von {{ currentVote.max }}
      </span>
    </template>
    <template v-else>
      <!-- only text visualisierung -->
      <p>Verfügbare {{ weightedPointsWord }}: {{ currentVote.max - currentVote.used }} von {{ currentVote.max }}</p>
    </template>
    <hr />
  </div>
</template>
<script>
import { computed, onMounted, reactive, ref, toRefs, watch } from '@vue/runtime-core';
import { userStore } from '@/store/user-store';
import { projectStore } from '@/store/project-store';
export default {
  name: 'topic-current-vote-status',

  props: {
    topic: {
      required: true,
      type: Object,
    },
  },

  setup(props, context) {
    const isLoggedIn = computed(() => {
      return userStore.isLoggedIn();
    });

    const relevantTopic = computed(() => {
      if (props.topic.votetype == 'weighted_support') {
        return props.topic;
      }
    });
    const project = computed(() => {
      return projectStore.getState().project;
    });
    const faIcon = computed(() => {
      if (project.value && project.value.config?.weighted_support_icon) {
        return project.value.config?.weighted_support_icon;
      }
      return null;
    });

    const currentVoteStatus = computed(() => {
      return projectStore.getState().currentVoteStatus;
    });

    const currentVote = computed(() => {
      if (currentVoteStatus.value == null) {
        return null;
      }

      // prioritize project here if configured
      if (project.value && project.value.max_votes_per_user && currentVoteStatus.value.project_limit_sum) {
        return {
          max: Number(project.value.max_votes_per_user),
          used: Number(currentVoteStatus.value.project_limit_sum.sum),
        };
      } else if (
        relevantTopic.value &&
        relevantTopic.value.max_votes_per_user &&
        currentVoteStatus.value.topic_limit_sum
      ) {
        return {
          max: Number(relevantTopic.value.max_votes_per_user),
          used: Number(currentVoteStatus.value.topic_limit_sum.sum),
        };
      }
    });

    const iconsArray = computed(() => {
      if (currentVote.value !== null && currentVote.value.max > 0) {
        let columns = 8;
        if (
          project.value &&
          project.value.config.weighted_support_icon_columns &&
          Number(project.value.config.weighted_support_icon_columns) >= 5
        ) {
          columns = Number(project.value.config.weighted_support_icon_columns);
        }
        const rows = Math.ceil(currentVote.value.max / columns);
        let used = currentVote.value.used;
        let col_count = currentVote.value.max;
        const resultArr = [];

        for (let i = 0; i < rows; i++) {
          let colsLeft = columns;
          if (col_count < columns) {
            colsLeft = col_count;
          }
          col_count -= columns;
          let rowArr = Array(colsLeft).fill('available');
          if (used >= colsLeft) {
            rowArr = rowArr.fill('used');
            used -= colsLeft;
          } else if (used > 0) {
            rowArr = rowArr.fill('used', 0, used);
            used = 0;
          }
          resultArr.push(rowArr);
        }
        return resultArr;
      }
      return [];
    });

    const weightedPointsWord = computed(() => {
      if (project.value && project.value.config?.weighted_support_word) {
        return project.value.config.weighted_support_word;
      }
      return 'Punkte';
    });

    const showCurrentVoteStatus = computed(() => {
      if (relevantTopic.value && relevantTopic.value.new_votes && currentVote.value !== null) {
        return projectStore.getState().project.max_votes_per_user || relevantTopic.value.max_votes_per_user;
      }
      return false;
    });

    // WATCHES
    watch(
      () => userStore.getState().user,
      (newUser, oldUser) => {
        // refresh the vote state again when user is logged-in/out
        if (
          (showCurrentVoteStatus.value && newUser == null && oldUser) ||
          (newUser && oldUser == null) ||
          newUser?.id != oldUser?.id
        ) {
          projectStore.refetchCurrentVoteStatus(relevantTopic.value.id);
        }
      }
    );
    // Lifecycle hooks
    onMounted(() => {
      // Check user's vote when this component is mounted
      projectStore.refetchCurrentVoteStatus(relevantTopic.value.id);
    });

    return {
      // computed
      isLoggedIn,
      showCurrentVoteStatus,
      currentVote,
      faIcon,
      weightedPointsWord,
      currentVoteStatus,
      iconsArray,
    };
  },
};
</script>
<style scoped lang="scss">
.current-vote-status {
  padding-top: 0.5rem;
}
.support_weight-icon {
  padding-right: 0.3rem;
  font-size: 1.8em;
  &.used {
    color: grey;
  }
  &.available {
    color: var(--wdw-secondary-color);
  }
}
</style>
